<template lang="html">
    <div>
        <form @submit.prevent="update">
            <preloader v-if="loading"></preloader>
            <form-user v-if="user && user.profile" :user="user" :errors="errors"></form-user>
            <div class="columns">
                <div class="column">
                    <div class="block">
                        <div class="field is-grouped">
                            <p class="control">
                                <button class="button is-success" type="submit">Actualizar</button>
                            </p>
                            <p class="control">
                                <button class="button" type="reset" @click="cancel">Cancelar</button>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                loading: false,
                errors: {},
                user: {},
                ready: false,
            }
        },
        mounted() {
            this.prepareComponent();
        },
        beforeRouteEnter(to, from, next) {
            next(vm => vm.prepareComponent())
        },
        props: {
            uuid: String,
        },
        methods: {
            prepareComponent() {
                this.loading = false;
                this.$root.preloader = false;
                this.getUser();
            },
            update() {
                this.$loader.show();
                this.errors = {};
                var checkRol = Array.isArray(this.user.role);
                var role = checkRol ? this.user.role[0] : this.user.role;

                var userData = [{
                    "name": this.user.profile.name,
                    "last_name": this.user.profile.last_name,
                    "other_name": this.user.profile.other_name,
                    "email": this.user.email,
                    "password": this.user.password,
                    "password_confirmation": this.user.password_confirmation,
                    "role": role,
                    "birthday": this.user.profile.birthday,
                    "gender": this.user.profile.gender,
                    'personal_phone': this.user.personal_phone,
                    'extension': this.user.extension
                }
                ];


                this.$http.put('/user/' + this.user.uuid, userData[0]).then(({data}) => {

                    console.log(data);
                    this.$notify.success(data);
                    this.$loader.hide();
                    this.$router.back();
                }, ({response}) => {
                    this.$loader.hide();
                    let data = response.data || {};
                    this.errors = data.errors || {};
                    this.$notify.danger(data.message);
                })
            },
            cancel() {
                this.$emit('cancel');
                this.$router.push('/admin/users');
            },
            getUser() {
                this.ready = false;
                this.$http.get('/user/' + this.uuid).then(response => {
                    this.user = response.data;
                    if(this.user.worker){
                        this.user.personal_phone = this.user.worker.personal_phone;
                        this.user.extension = this.user.worker.extension;
                        this.user.role = 'ivr_worker';
                    }
                    setTimeout(() => {
                        this.ready = true;
                    }, 500)
                }, error => {
                    this.ready = false;
                })
            },
        }
    }
</script>

<style lang="css">
</style>
